export const TRANSPORT_PORT_SEPARATOR = '-';
export const TRANSPORT_PROPS_SEPARATOR = ' ';
export const TRANSPORT_ID_SEPARATOR = ',';
export const TRANSPORT_CARRIER_SEPARATOR = ',';
export const TRANSPORT_FILTERS_SEPARATOR = ';';
export const SUGGESTION_ORDER_PREFIX = 'sug:';

export const enum SerializedAvailabilityOrder {
  None = '0',
  Cheapest = '1',
  Popular = '2',
}
